export default "__VITE_ASSET__7d657919__"